<div class="modal fade" bsModal #sessionWarningModal="bs-modal" [config]="{backdrop: 'static', keyboard: false}"
  tabindex="-1">
  <div class="modal-dialog" style="height:200px; width:500px;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title text-center">Session Expiring Soon</h4>
      </div>
      <div class="modal-body">
        <div class="alert alert-danger p m0 text-center">“Your session is about to expire. Please click on "Do Not
          Expire" to continue.”</div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-secondary" (click)="onDoNotExpire()">Do Not Expire</button>
      </div>
    </div>
  </div>
</div>